export default "__VITE_ASSET__CV0PchoX__"